import { getSidebarCustomize, customControlBackboneView } from ".";
/**
 * Register a custom control.
 *
 * @param controls
 */ function customControl(controls) {
    const customize = getSidebarCustomize();
    for (const type of Object.keys(controls)){
        const control = controls[type];
        // Register control in available constructors
        if (!customize.controlConstructor[type]) {
            customize.controlConstructor[type] = customControlBackboneView(control);
        }
    }
}
export { customControl };
